var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { RoleService } from '~/services/management-service/role.service';
import { PageService } from '~/utils/page.service';
import ModifyRole from '~/components/system-manage/role-mangae/modify-role.vue';
import ModulePermission from '~/components/system-manage/role-mangae/module-permission.vue';
import UserList from '~/components/system-manage/role-mangae/user-list.vue';
import { namespace } from 'vuex-class';
var systemModule = namespace('system-manage');
var RoleManage = /** @class */ (function (_super) {
    __extends(RoleManage, _super);
    function RoleManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.roleModel = {
            roleName: '',
            roleStatus: '',
        };
        _this.roleDataSet = [];
        _this.roleObj = {};
        _this.dialog = {
            modify: false,
            module: false,
            list: false,
        };
        return _this;
    }
    /**
     * 获取角色列表
     */
    RoleManage.prototype.refreshData = function () {
        var _this = this;
        this.roleService.getAllRoles(this.roleModel, this.pageService).subscribe(function (data) {
            _this.roleDataSet = data;
        });
    };
    RoleManage.prototype.mounted = function () {
        this.refreshData();
        this.updateResource();
    };
    __decorate([
        Dependencies(RoleService)
    ], RoleManage.prototype, "roleService", void 0);
    __decorate([
        Dependencies(PageService)
    ], RoleManage.prototype, "pageService", void 0);
    __decorate([
        systemModule.Action
    ], RoleManage.prototype, "updateResource", void 0);
    RoleManage = __decorate([
        Auth(12),
        Layout('workspace'),
        Component({
            components: {
                ModulePermission: ModulePermission,
                ModifyRole: ModifyRole,
                UserList: UserList,
            },
        })
    ], RoleManage);
    return RoleManage;
}(Vue));
export default RoleManage;
